import { render, staticRenderFns } from "./OtherAccount.vue?vue&type=template&id=3ff4572b&scoped=true&"
import script from "./OtherAccount.vue?vue&type=script&lang=js&"
export * from "./OtherAccount.vue?vue&type=script&lang=js&"
import style0 from "./OtherAccount.vue?vue&type=style&index=0&id=3ff4572b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff4572b",
  null
  
)

export default component.exports